
(function(){
if(window.__sfgNameOrnament||!document.getElementById('boardSvg'))return;   // run once, and only on pages that have the section
window.__sfgNameOrnament=true;

// Library loader
function loadScript(urls){return new Promise((res,rej)=>{let i=0;function n(){if(i>=urls.length){rej(new Error('All CDNs failed'));return;}const s=document.createElement('script');s.src=urls[i++];s.onload=res;s.onerror=()=>{s.remove();n();};document.head.appendChild(s);}n();});}
const LIB={opentype:['https://cdn.jsdelivr.net/npm/opentype.js@1.3.4/dist/opentype.min.js','https://unpkg.com/opentype.js@1.3.4/dist/opentype.min.js'],clipper:['https://cdn.jsdelivr.net/npm/clipper-lib/clipper.js','https://cdn.jsdelivr.net/npm/clipper-lib@6.4.2/clipper.js','https://unpkg.com/clipper-lib/clipper.js','https://unpkg.com/clipper-lib@6.4.2/clipper.js','https://cdnjs.cloudflare.com/ajax/libs/clipper-lib/6.4.2/clipper.js']};

// Constants
const W=760,H=720;
// Snowflake halves (snowflake2.svg = TOP half, snowflake1.svg = BOTTOM half), native coordinates
const SF_CX=268.010;                                  // horizontal centre of both halves
const TOP_Y0=130.193,TOP_Y1=318.250;                // top half: tip -> flat edge (faces the name)
const BOT_Y0=130.192,BOT_Y1=318.249;                // bottom half: flat edge (faces the name) -> tip
const SF_SCALE=1;
const NAME_OVERLAP=3.5;                              // px the name overlaps each snowflake half
const BAR_HALF=150;                                  // half-width of the span where the halves face the name (flat edge + arm tips)
const BOT_OVERLAP_GROW=0.04;                        // extra bottom overlap per pt of letter size above 100
const PREVIEW_PAD=24;                                // margin kept around the artwork in the preview
const FLATTEN_TOL=0.35;
const RDP_EPS=0.6;
const CS=100; // Clipper scale (coords -> integers)
const GAP=20;
const WELD_PAD=0;
const CUT_BOUNDARY_BAND=1.1;


const INTERNAL_SEAM_EPS=1.2;
const MIN_SEAM_LEN=8;
const BEIGE='#C9A882',BROWN='#5C3317',BACK_FILL='#8B5534',BG='#ffffff';
const PSW=1.4;
const BACK_OFFSET=7;

const SNOW_TOP='M122.373,262.964c1.61,0.92,3.34,1.78,5.2,2.03l-27.26,7.74c-6.11,6.93-2.28,17.12,7.39,17.21c11.66,0.1,38.52-10.57,47.74-7.78c3.17,0.96,7.24,5.59,11.05,6.18c0.27,1.59-1.96,1.56-3.1,1.87c-9.82,2.66-39.95,6.07-46.2,10.51c-7.97,5.66-2.99,18.04,7.28,17.38c20.93-1.34,45.83-11.14,67.08-13.7l24.416,13.846h105.596l23.367-13.295l67.733,13.295h4.104c7.037-1.742,10.042-12.516,4.052-16.965c-5.38-4-49.86-9.82-49.75-12.38c4.45-2.77,9.56-7.29,14.97-7.32c11.62-0.06,30.39,8.19,42.41,8.93c3.95,0.24,8.66-1.44,9.91-5.44c0.94-3.77,1.24-8.85-1.78-11.67l-26.62-6.72c5.87-6.37,36.4-18.59,37.77-25.61c1.67-8.58-4.6-15.71-13.35-13.35c-4.54,1.22-33.06,20.91-34.43,19.48l6.68-24.95c-5.4-10.3-14.44-10.32-19.46,0.52c-4.55,9.83-8.07,32.21-12.94,39.31c-1.13,1.65-13.49,9.32-14.31,8.47c2.84-14.55,11.29-30.18,13.94-44.41c2.25-12.07-7.1-19.06-16.8-11.25l-23,72.07l-36.4,20.28l25.33-41.96c0.64-12.17-10.3-18.29-19.12-7.97c-9.74,11.4-15.17,27.4-25.11,38.81v-38.36c2.09-2.33,4.66-4.28,6.64-6.7c11.86-14.49,28.08-31.23,38.29-46.21c4-5.87,4.45-13.66-2.97-16.85c-6.26-2.7-9.11,1.27-13.02,5.3c-7.7,7.94-14.29,18.83-21.69,27.23l-7.24,6.65c0.5-5.12-1.1-11.56,0.84-16.39c3.98-9.95,24.05-26.32,30.14-36.56c4.13-5.77-2.62-14.14-8.47-14.66c-7.1-0.64-15.97,15.75-21.39,19.8l-1.96-44.19c-2.27-5.76-14-6.47-17.48-2.47c-0.49,0.56-2.81,5.74-2.81,6.08v40.58l-18.58-18.67c-7.46-1.69-11.58,2-12.61,9.22c0,3.28,2.73,6.27,4.54,8.87c3.3,4.73,26.66,29.1,26.66,31.15v17.23l-32.94-37.66c-6.29-3.56-14.16-0.09-14.86,7.2c-0.39,4.04,2.3,6.78,4.46,9.87c11.99,17.19,30.41,33.23,43.11,50.28l1.33,39.24c-1.48-0.3-2.32-1.85-3.13-2.98c-6.62-9.17-17.49-32.32-24.74-38.63c-7.84-6.83-17.57-0.28-16.64,9.93c0.66,7.19,19.1,30.25,23.84,38.47c0.81,1.41,2.15,2.47,1.77,4.34l-37.46-21.45l-22.53-71.42c-6.41-5.85-17.03-2.61-16.81,6.7l14.54,50.59c-3.13-2.96-11.71-5.7-13.83-8.95c-5.04-7.73-8.94-29.89-13.41-39.95c-3.93-8.84-9.93-11.06-17.74-4.44c-4.95,6.9,4.31,22.23,6.09,29.98l-38.61-22.02c-10.2,0-16.39,11.15-8.49,18.54C96.633,249.524,115.183,258.844,122.373,262.964z';
const SNOW_BOT='M413.647,185.478c-1.61-0.92-3.34-1.78-5.2-2.03l27.26-7.74c6.11-6.93,2.28-17.12-7.39-17.21c-11.66-0.1-38.52,10.57-47.74,7.78c-3.17-0.96-7.24-5.59-11.05-6.18c-0.27-1.59,1.96-1.56,3.1-1.87c9.82-2.66,39.95-6.07,46.2-10.51c7.97-5.66,2.99-18.04-7.28-17.38c-20.93,1.34-45.83,11.14-67.08,13.7l-24.416-13.846H214.454l-23.367,13.295l-67.733-13.295h-4.104c-7.037,1.742-10.042,12.516-4.052,16.965c5.38,4,49.86,9.82,49.75,12.38c-4.45,2.77-9.56,7.29-14.97,7.32c-11.62,0.06-30.39-8.19-42.41-8.93c-3.95-0.24-8.66,1.44-9.91,5.44c-0.94,3.77-1.24,8.85,1.78,11.67l26.62,6.72c-5.87,6.37-36.4,18.59-37.77,25.61c-1.67,8.58,4.6,15.71,13.35,13.35c4.54-1.22,33.06-20.91,34.43-19.48l-6.68,24.95c5.4,10.3,14.44,10.32,19.46-0.52c4.55-9.83,8.07-32.21,12.94-39.31c1.13-1.65,13.49-9.32,14.31-8.47c-2.84,14.55-11.29,30.18-13.94,44.41c-2.25,12.07,7.1,19.06,16.8,11.25l23-72.07l36.4-20.28l-25.33,41.96c-0.64,12.17,10.3,18.29,19.12,7.97c9.74-11.4,15.17-27.4,25.11-38.81v38.36c-2.09,2.33-4.66,4.28-6.64,6.7c-11.86,14.49-28.08,31.23-38.29,46.21c-4,5.87-4.45,13.66,2.97,16.85c6.26,2.7,9.11-1.27,13.02-5.3c7.7-7.94,14.29-18.83,21.69-27.23l7.24-6.65c-0.5,5.12,1.1,11.56-0.84,16.39c-3.98,9.95-24.05,26.32-30.14,36.56c-4.13,5.77,2.62,14.14,8.47,14.66c7.1,0.64,15.97-15.75,21.39-19.8l1.96,44.19c2.27,5.76,14,6.47,17.48,2.47c0.49-0.56,2.81-5.74,2.81-6.08v-40.58l18.58,18.67c7.46,1.69,11.58-2,12.61-9.22c0-3.28-2.73-6.27-4.54-8.87c-3.3-4.73-26.66-29.1-26.66-31.15v-17.23l32.94,37.66c6.29,3.56,14.16,0.09,14.86-7.2c0.39-4.04-2.3-6.78-4.46-9.87c-11.99-17.19-30.41-33.23-43.11-50.28l-1.33-39.24c1.48,0.3,2.32,1.85,3.13,2.98c6.62,9.17,17.49,32.32,24.74,38.63c7.84,6.83,17.57,0.28,16.64-9.93c-0.66-7.19-19.1-30.25-23.84-38.47c-0.81-1.41-2.15-2.47-1.77-4.34l37.46,21.45l22.53,71.42c6.41,5.85,17.03,2.61,16.81-6.7l-14.54-50.59c3.13,2.96,11.71,5.7,13.83,8.95c5.04,7.73,8.94,29.89,13.41,39.95c3.93,8.84,9.93,11.06,17.74,4.44c4.95-6.9-4.31-22.23-6.09-29.98l38.61,22.02c10.2,0,16.39-11.15,8.49-18.54C439.387,198.918,420.837,189.598,413.647,185.478z';

// State
const FONTS={
  chewy:   {label:'Chewy',   family:"'Chewy',cursive",    pkg:'chewy',    size:160,spacing:-17,fit:400},
  atma:    {label:'Atma',    family:"'Atma',cursive",     pkg:'atma',     size:159,spacing:-23,fit:344},
  boogaloo:{label:'Boogaloo',family:"'Boogaloo',cursive", pkg:'boogaloo', size:187,spacing:-25,fit:349},
  merienda:{label:'Merienda',family:"'Merienda',cursive", pkg:'merienda', size:148,spacing:-28,fit:411},
  rancho:  {label:'Rancho',  family:"'Rancho',cursive",   pkg:'rancho',   size:220,spacing:-21,fit:409},
};
const fontCache={};
const DEF={name:'Samantha',fontKey:'boogaloo',fontSize:187,letterSpacing:-25,hoopEnabled:true,exportHeightMm:101.6,exportUnit:'in'};
const S={...DEF};
let font=null,data=null,timer=null,ready=false;
const EXPORT_MIN_MM=40,EXPORT_MAX_MM=520;
function mmToUnit(mm,unit){return unit==='in'?mm/25.4:mm;}
function unitToMm(value,unit){return unit==='in'?value*25.4:value;}
function fmtMeasure(value,unit){
  const digits=unit==='in'?2:1;
  return parseFloat(value.toFixed(digits)).toString();
}
function currentBackBounds(){return data&&data.backCutBounds?data.backCutBounds:{x:0,y:0,w:W,h:H};}
function exportScaleInUnit(unit){
  const bounds=currentBackBounds();
  return mmToUnit(S.exportHeightMm,unit)/Math.max(bounds.h,1e-6);
}
function baseLayerWidthInUnit(unit){
  const bounds=currentBackBounds();
  return bounds.w*exportScaleInUnit(unit);
}
function fmtExportDims(){
  const unit=S.exportUnit;
  const w=baseLayerWidthInUnit(unit),h=mmToUnit(S.exportHeightMm,unit);
  return `Final size: ${fmtMeasure(w,unit)} x ${fmtMeasure(h,unit)} ${unit}`;
}
function syncExportUi(){
  const input=document.getElementById('ehInput');
  if(input){
    input.step=S.exportUnit==='in'?'0.01':'0.1';
    input.min=fmtMeasure(mmToUnit(EXPORT_MIN_MM,S.exportUnit),S.exportUnit);
    input.max=fmtMeasure(mmToUnit(EXPORT_MAX_MM,S.exportUnit),S.exportUnit);
    input.value=fmtMeasure(mmToUnit(S.exportHeightMm,S.exportUnit),S.exportUnit);
  }
  const dims=document.getElementById('exportDims');
  if(dims)dims.textContent=fmtExportDims();
  document.querySelectorAll('#unitSeg .sb').forEach(b=>b.classList.toggle('on',b.dataset.unit===S.exportUnit));
}

// Snowflake layout: halves follow the name's height (name never moves up/down)
function snowLayout(nameH,botOv=NAME_OVERLAP){
  const topH=(TOP_Y1-TOP_Y0)*SF_SCALE,botH=(BOT_Y1-BOT_Y0)*SF_SCALE;
  const total=topH+nameH+botH-NAME_OVERLAP-botOv;
  const topY=(H-total)/2;                 // screen y of top tip
  const nameTop=topY+topH-NAME_OVERLAP;   // where the top half meets the name
  const nameBottom=nameTop+nameH;         // where the bottom half meets the name
  const botTop=nameBottom-botOv;          // flat edge of bottom half
  const tx=W/2-SF_CX*SF_SCALE;
  return{topY,nameTop,nameBottom,
    topTf:{sc:SF_SCALE,tx,ty:topY-TOP_Y0*SF_SCALE},
    botTf:{sc:SF_SCALE,tx,ty:botTop-BOT_Y0*SF_SCALE}};
}
function gTf(t){return `translate(${t.tx.toFixed(2)},${t.ty.toFixed(2)}) scale(${t.sc.toFixed(5)})`;}

// Hoop
const HR=20,hIR=11;
function hoopPos(topY){return{cx:W/2,cy:topY-hIR-1};} // loop sits just above the top tip
function circlePath(cx,cy,r){const x0=(cx-r).toFixed(2),x1=(cx+r).toFixed(2),c=cy.toFixed(2);return `M${x0},${c} A${r},${r} 0 1 0 ${x1},${c} A${r},${r} 0 1 0 ${x0},${c} Z`;}
function ringPath(h){return `${circlePath(h.cx,h.cy,HR)} ${circlePath(h.cx,h.cy,hIR)}`;}
function circleContour(cx,cy,r,steps=96){
  const pts=[];
  for(let i=0;i<steps;i++){
    const a=(i/steps)*Math.PI*2;
    pts.push([cx+Math.cos(a)*r,cy+Math.sin(a)*r]);
  }
  return pts;
}

// SVG path parser
function parsePath(d){
  const segs=d.match(/[MmLlCcQqZzHhVvSsAa][^MmLlCcQqZzHhVvSsAa]*/g)||[];
  const nr=/-?(?:\d+\.?\d*|\.\d+)(?:[eE][+-]?\d+)?/g;
  const c=[];let cx=0,cy=0,sx=0,sy=0;
  for(const seg of segs){const t=seg[0],n=(seg.slice(1).match(nr)||[]).map(Number);
    if(t==='M'){for(let i=0;i<n.length;i+=2){c.push({type:i?'L':'M',x:n[i],y:n[i+1]});cx=n[i];cy=n[i+1];if(!i){sx=cx;sy=cy;}}}
    else if(t==='m'){for(let i=0;i<n.length;i+=2){cx+=n[i];cy+=n[i+1];c.push({type:i?'L':'M',x:cx,y:cy});if(!i){sx=cx;sy=cy;}}}
    else if(t==='L'){for(let i=0;i<n.length;i+=2){c.push({type:'L',x:n[i],y:n[i+1]});cx=n[i];cy=n[i+1];}}
    else if(t==='l'){for(let i=0;i<n.length;i+=2){cx+=n[i];cy+=n[i+1];c.push({type:'L',x:cx,y:cy});}}
    else if(t==='H'){for(let i=0;i<n.length;i++){cx=n[i];c.push({type:'L',x:cx,y:cy});}}
    else if(t==='h'){for(let i=0;i<n.length;i++){cx+=n[i];c.push({type:'L',x:cx,y:cy});}}
    else if(t==='V'){for(let i=0;i<n.length;i++){cy=n[i];c.push({type:'L',x:cx,y:cy});}}
    else if(t==='v'){for(let i=0;i<n.length;i++){cy+=n[i];c.push({type:'L',x:cx,y:cy});}}
    else if(t==='C'){for(let i=0;i<n.length;i+=6){c.push({type:'C',x1:n[i],y1:n[i+1],x2:n[i+2],y2:n[i+3],x:n[i+4],y:n[i+5]});cx=n[i+4];cy=n[i+5];}}
    else if(t==='c'){for(let i=0;i<n.length;i+=6){c.push({type:'C',x1:cx+n[i],y1:cy+n[i+1],x2:cx+n[i+2],y2:cy+n[i+3],x:cx+n[i+4],y:cy+n[i+5]});cx+=n[i+4];cy+=n[i+5];}}
    else if(t==='Q'){for(let i=0;i<n.length;i+=4){c.push({type:'Q',x1:n[i],y1:n[i+1],x:n[i+2],y:n[i+3]});cx=n[i+2];cy=n[i+3];}}
    else if(t==='q'){for(let i=0;i<n.length;i+=4){c.push({type:'Q',x1:cx+n[i],y1:cy+n[i+1],x:cx+n[i+2],y:cy+n[i+3]});cx+=n[i+2];cy+=n[i+3];}}
    else if(t==='Z'||t==='z'){c.push({type:'Z'});cx=sx;cy=sy;}}
  return c;
}
function xfCmds(c,sc,tx,ty){return c.map(p=>{if(p.type==='M'||p.type==='L')return{type:p.type,x:p.x*sc+tx,y:p.y*sc+ty};if(p.type==='C')return{type:'C',x1:p.x1*sc+tx,y1:p.y1*sc+ty,x2:p.x2*sc+tx,y2:p.y2*sc+ty,x:p.x*sc+tx,y:p.y*sc+ty};if(p.type==='Q')return{type:'Q',x1:p.x1*sc+tx,y1:p.y1*sc+ty,x:p.x*sc+tx,y:p.y*sc+ty};return p;});}

// Font
async function loadFont(key){
  if(!ready)return false;
  if(fontCache[key]){font=fontCache[key];return true;}
  const F=FONTS[key];showOv('Loading '+F.label+'...');data=null;document.getElementById('dlBtn').disabled=true;
  const f=`files/${F.pkg}-latin-400-normal.woff`,base=`https://cdn.jsdelivr.net/npm/@fontsource/${F.pkg}`;
  for(const url of [`${base}/${f}`,`${base}@5/${f}`,`${base}@4/${f}`]){
    try{const r=await fetch(url);if(!r.ok)throw 0;font=fontCache[key]=opentype.parse(await r.arrayBuffer());hideOv();return true;}catch(e){}
  }
  return false;
}

// Bezier flatten
function mp(a,b){return[(a[0]+b[0])*.5,(a[1]+b[1])*.5];}
function fc(p0,p1,p2,p3,tq,o){
  const ux=3*p1[0]-2*p0[0]-p3[0],uy=3*p1[1]-2*p0[1]-p3[1],vx=3*p2[0]-2*p3[0]-p0[0],vy=3*p2[1]-2*p3[1]-p0[1];
  if(Math.max(ux*ux+uy*uy,vx*vx+vy*vy)<=16*tq){o.push(p3);return;}
  const q0=mp(p0,p1),q1=mp(p1,p2),q2=mp(p2,p3),r0=mp(q0,q1),r1=mp(q1,q2),s=mp(r0,r1);
  fc(p0,q0,r0,s,tq,o);fc(s,r1,q2,p3,tq,o);
}
function flatten(cmds,tol){
  const tq=tol*tol,cs=[];let pts=[],lx=0,ly=0;
  for(const c of cmds){
    if(c.type==='M'){if(pts.length>=3)cs.push(pts);pts=[[c.x,c.y]];lx=c.x;ly=c.y;}
    else if(c.type==='L'){pts.push([c.x,c.y]);lx=c.x;ly=c.y;}
    else if(c.type==='C'){const f=[];fc([lx,ly],[c.x1,c.y1],[c.x2,c.y2],[c.x,c.y],tq,f);pts.push(...f);lx=c.x;ly=c.y;}
    else if(c.type==='Q'){const x1=lx+(2/3)*(c.x1-lx),y1=ly+(2/3)*(c.y1-ly),x2=c.x+(2/3)*(c.x1-c.x),y2=c.y+(2/3)*(c.y1-c.y),f=[];fc([lx,ly],[x1,y1],[x2,y2],[c.x,c.y],tq,f);pts.push(...f);lx=c.x;ly=c.y;}
    else if(c.type==='Z'){if(pts.length>=3)cs.push(pts);pts=[];}
  }
  if(pts.length>=3)cs.push(pts);return cs;
}

// RDP simplification
function rdp(pts,e){
  if(pts.length<=2)return pts.slice();
  const a=pts[0],b=pts[pts.length-1],dx=b[0]-a[0],dy=b[1]-a[1],l=Math.sqrt(dx*dx+dy*dy)||1;
  let md=0,mi=1;
  for(let i=1;i<pts.length-1;i++){const d=Math.abs(dy*pts[i][0]-dx*pts[i][1]+b[0]*a[1]-b[1]*a[0])/l;if(d>md){md=d;mi=i;}}
  if(md>e){const L=rdp(pts.slice(0,mi+1),e),R=rdp(pts.slice(mi),e);return[...L.slice(0,-1),...R];}
  return[a,b];
}

// Smoothing: contour -> SVG with C commands. Sharp corners stay sharp; curve handles never exceed 1/3 of their own segment (no overshoot)
const CORNER_COS=0.8;   // turns sharper than ~37 degrees are kept as corners
function smoothPts(s,closed){
  const n=s.length,f=x=>x.toFixed(2);
  const at=i=>closed?s[(i+n)%n]:s[Math.max(0,Math.min(n-1,i))];
  const dirAt=i=>{                       // tangent at vertex i, or null for a corner / open end
    if(!closed&&(i===0||i===n-1))return null;
    const a=at(i-1),b=at(i),c=at(i+1);
    const u=[b[0]-a[0],b[1]-a[1]],v=[c[0]-b[0],c[1]-b[1]],lu=Math.hypot(u[0],u[1])||1,lv=Math.hypot(v[0],v[1])||1;
    if((u[0]*v[0]+u[1]*v[1])/(lu*lv)<CORNER_COS)return null;
    const t=[c[0]-a[0],c[1]-a[1]],lt=Math.hypot(t[0],t[1])||1;return[t[0]/lt,t[1]/lt];
  };
  let d=`M${f(s[0][0])},${f(s[0][1])}`;
  const segs=closed?n:n-1;
  for(let i=0;i<segs;i++){
    const p1=at(i),p2=at(i+1),L=Math.hypot(p2[0]-p1[0],p2[1]-p1[1])/3,t1=dirAt(i),t2=dirAt(i+1);
    const st1=[p1[0]+(p2[0]-p1[0])/3,p1[1]+(p2[1]-p1[1])/3],st2=[p2[0]-(p2[0]-p1[0])/3,p2[1]-(p2[1]-p1[1])/3];   // straight-line handles
    let c1=t1?[p1[0]+t1[0]*L,p1[1]+t1[1]*L]:st1;
    let c2=t2?[p2[0]-t2[0]*L,p2[1]-t2[1]*L]:st2;
    // the simplified outline is within RDP_EPS of its chord, so a curve that bulges away from the chord is overshooting: keep that edge straight
    const cl=Math.hypot(p2[0]-p1[0],p2[1]-p1[1])||1;
    for(const t of [0.25,0.5,0.75]){
      const u=1-t,qx=u*u*u*p1[0]+3*u*u*t*c1[0]+3*u*t*t*c2[0]+t*t*t*p2[0],qy=u*u*u*p1[1]+3*u*u*t*c1[1]+3*u*t*t*c2[1]+t*t*t*p2[1];
      if(Math.abs((p2[0]-p1[0])*(qy-p1[1])-(p2[1]-p1[1])*(qx-p1[0]))/cl>RDP_EPS){c1=st1;c2=st2;break;}
    }
    d+=` C${f(c1[0])},${f(c1[1])} ${f(c2[0])},${f(c2[1])} ${f(p2[0])},${f(p2[1])}`;
  }
  return d;
}
function closedSmooth(pts){
  if(!pts||pts.length<3)return'';
  const inp=[...pts,pts[0]];
  let s=rdp(inp,RDP_EPS);s.pop();
  if(s.length<3)s=pts;
  return smoothPts(s,true)+' Z';
}
function openSmooth(pts){
  if(!pts||pts.length<2)return'';
  let s=rdp(pts,RDP_EPS);
  if(s.length<2)s=pts;
  if(s.length===2)return`M${s[0][0].toFixed(2)},${s[0][1].toFixed(2)} L${s[1][0].toFixed(2)},${s[1][1].toFixed(2)}`;
  return smoothPts(s,false);
}

// Raw fill path (L-commands, for preview fill)
function rawFillPath(contours){
  return contours.map(c=>{
    if(c.length<2)return'';
    let d=`M${c[0][0].toFixed(2)},${c[0][1].toFixed(2)}`;
    for(let i=1;i<c.length;i++)d+=` L${c[i][0].toFixed(2)},${c[i][1].toFixed(2)}`;
    return d+' Z';
  }).filter(Boolean).join(' ');
}
function clipperBounds(paths){
  let minX=Infinity,minY=Infinity,maxX=-Infinity,maxY=-Infinity;
  for(const path of paths||[]){
    for(const pt of path){
      const x=pt.X/CS,y=pt.Y/CS;
      if(x<minX)minX=x;
      if(y<minY)minY=y;
      if(x>maxX)maxX=x;
      if(y>maxY)maxY=y;
    }
  }
  if(!isFinite(minX))return{x:0,y:0,w:W,h:H};
  return{x:minX,y:minY,w:maxX-minX,h:maxY-minY};
}

// ==================================================================
// CLIPPER HELPERS
// ==================================================================

function toCP(pts){return pts.map(p=>({X:Math.round(p[0]*CS),Y:Math.round(p[1]*CS)}));}
function fromCP(path){return path.map(p=>[p.X/CS,p.Y/CS]);}
function signedArea(pts){let a=0;for(let i=0;i<pts.length;i++){const j=(i+1)%pts.length;a+=pts[i][0]*pts[j][1]-pts[j][0]*pts[i][1];}return a/2;}
function ensureWinding(pts,clockwise){const isClockwise=signedArea(pts)<0;return isClockwise===clockwise?pts:pts.slice().reverse();}
function contourInside(contour,container){for(const pt of contour){const r=ClipperLib.Clipper.PointInPolygon({X:Math.round(pt[0]*CS),Y:Math.round(pt[1]*CS)},toCP(container));if(r!==0)return r!==-1;}return false;}
function normalizeCompoundContours(contours){
  return contours.filter(c=>c.length>=3).map((contour,index,all)=>{
    let depth=0;
    for(let i=0;i<all.length;i++){
      if(i===index)continue;
      if(contourInside(contour,all[i]))depth++;
    }
    const isHole=depth%2===1;
    return ensureWinding(contour,!isHole);
  });
}

// Union multiple contour sets into one clean polygon set
function clipperUnion(contourSets){
  const subject=[];
  for(const contours of contourSets){
    const normalized=normalizeCompoundContours(contours);
    for(const c of normalized){
      subject.push(toCP(c));
    }
  }
  if(subject.length===0)return[];

  const clipper=new ClipperLib.Clipper();
  const simplified=ClipperLib.Clipper.SimplifyPolygons(subject,ClipperLib.PolyFillType.pftNonZero);
  clipper.AddPaths(simplified,ClipperLib.PolyType.ptSubject,true);
  const sol=new ClipperLib.Paths();
  clipper.Execute(ClipperLib.ClipType.ctUnion,sol,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);

  const cleaned=ClipperLib.Clipper.CleanPolygons(sol,0.15*CS);
  const minArea=20*CS*CS;
  return cleaned.filter(p=>Math.abs(ClipperLib.Clipper.Area(p))>minArea);
}

// Build area from multiple letter contour arrays (union them)
function buildArea(letterContourArrays){
  return clipperUnion(letterContourArrays);
}
function diffAreas(subjectArea,clipArea){
  if(!subjectArea||subjectArea.length===0)return[];
  if(!clipArea||clipArea.length===0)return subjectArea.slice();
  const clipper=new ClipperLib.Clipper();
  clipper.AddPaths(subjectArea,ClipperLib.PolyType.ptSubject,true);
  clipper.AddPaths(clipArea,ClipperLib.PolyType.ptClip,true);
  const sol=new ClipperLib.Paths();
  clipper.Execute(ClipperLib.ClipType.ctDifference,sol,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
  const cleaned=ClipperLib.Clipper.CleanPolygons(sol,0.15*CS);
  const minArea=20*CS*CS;
  return cleaned.filter(p=>Math.abs(ClipperLib.Clipper.Area(p))>minArea);
}
function intersectAreas(subjectArea,clipArea){
  if(!subjectArea||subjectArea.length===0||!clipArea||clipArea.length===0)return[];
  const clipper=new ClipperLib.Clipper();
  clipper.AddPaths(subjectArea,ClipperLib.PolyType.ptSubject,true);
  clipper.AddPaths(clipArea,ClipperLib.PolyType.ptClip,true);
  const sol=new ClipperLib.Paths();
  clipper.Execute(ClipperLib.ClipType.ctIntersection,sol,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
  const cleaned=ClipperLib.Clipper.CleanPolygons(sol,0.15*CS);
  const minArea=20*CS*CS;
  return cleaned.filter(p=>Math.abs(ClipperLib.Clipper.Area(p))>minArea);
}
function offsetAreas(paths,delta){
  if(!paths||paths.length===0||!delta)return paths?paths.slice():[];
  const co=new ClipperLib.ClipperOffset(2,0.25*CS);
  co.AddPaths(paths,ClipperLib.JoinType.jtRound,ClipperLib.EndType.etClosedPolygon);
  const sol=new ClipperLib.Paths();
  co.Execute(sol,delta*CS);
  const cleaned=ClipperLib.Clipper.CleanPolygons(sol,0.15*CS);
  const minArea=20*CS*CS;
  return cleaned.filter(p=>Math.abs(ClipperLib.Clipper.Area(p))>minArea);
}
function unionAreas(paths){
  if(!paths||paths.length===0)return[];
  const clipper=new ClipperLib.Clipper();
  clipper.AddPaths(paths,ClipperLib.PolyType.ptSubject,true);
  const sol=new ClipperLib.Paths();
  clipper.Execute(ClipperLib.ClipType.ctUnion,sol,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
  const cleaned=ClipperLib.Clipper.CleanPolygons(sol,0.15*CS);
  const minArea=20*CS*CS;
  return cleaned.filter(p=>Math.abs(ClipperLib.Clipper.Area(p))>minArea);
}
function buildContourBandArea(contours,band){
  const bands=[];
  for(const contour of contours){
    if(!contour||contour.length<3)continue;
    const cp=[toCP(contour)];
    const outer=offsetAreas(cp,band);
    const inner=offsetAreas(cp,-band);
    const bandArea=inner.length?diffAreas(outer,inner):outer;
    bands.push(...bandArea);
  }
  return unionAreas(bands);
}
function buildPolylineBandArea(polylines,band){
  if(!polylines||polylines.length===0||!band)return[];
  const openPaths=[];
  for(const line of polylines){
    if(!line||line.length<2)continue;
    openPaths.push(toCP(line));
  }
  if(!openPaths.length)return[];
  const co=new ClipperLib.ClipperOffset(2,0.25*CS);
  co.AddPaths(openPaths,ClipperLib.JoinType.jtRound,ClipperLib.EndType.etOpenRound);
  const sol=new ClipperLib.Paths();
  co.Execute(sol,band*CS);
  const cleaned=ClipperLib.Clipper.CleanPolygons(sol,0.15*CS);
  const minArea=20*CS*CS;
  return cleaned.filter(p=>Math.abs(ClipperLib.Clipper.Area(p))>minArea);
}
function polylineLength(pts){
  let len=0;
  for(let i=1;i<pts.length;i++)len+=Math.hypot(pts[i][0]-pts[i-1][0],pts[i][1]-pts[i-1][1]);
  return len;
}
function seamProbeAt(seg,fraction=0.5){
  if(seg.length<2)return null;
  const total=polylineLength(seg);
  if(!total)return null;
  let target=total*Math.max(0,Math.min(1,fraction)),acc=0;
  for(let i=1;i<seg.length;i++){
    const a=seg[i-1],b=seg[i];
    const len=Math.hypot(b[0]-a[0],b[1]-a[1]);
    if(!len)continue;
    if(acc+len>=target){
      const t=(target-acc)/len;
      const x=a[0]+(b[0]-a[0])*t,y=a[1]+(b[1]-a[1])*t;
      const nx=-(b[1]-a[1])/len,ny=(b[0]-a[0])/len;
      return {mid:[x,y],normal:[nx,ny]};
    }
    acc+=len;
  }
  const a=seg[0],b=seg[seg.length-1],len=Math.hypot(b[0]-a[0],b[1]-a[1]);
  if(!len)return null;
  return {mid:[(a[0]+b[0])/2,(a[1]+b[1])/2],normal:[-(b[1]-a[1])/len,(b[0]-a[0])/len]};
}
function isInternalSeam(seg,solidArea){
  if(!solidArea||solidArea.length===0)return false;
  for(const t of [0.2,0.5,0.8]){
    const probe=seamProbeAt(seg,t);
    if(!probe)return false;
    const [x,y]=probe.mid,[nx,ny]=probe.normal;
    const p1=[x+nx*INTERNAL_SEAM_EPS,y+ny*INTERNAL_SEAM_EPS];
    const p2=[x-nx*INTERNAL_SEAM_EPS,y-ny*INTERNAL_SEAM_EPS];
    if(!ptStrictInArea(p1,solidArea)||!ptStrictInArea(p2,solidArea))return false;
  }
  return true;
}





// Point-in-polygon test against Clipper solution paths
// Returns true if point is inside filled area (NonZero rule)
function ptInArea(pt,solPaths){
  if(!solPaths||solPaths.length===0)return false;
  const cp={X:Math.round(pt[0]*CS),Y:Math.round(pt[1]*CS)};
  let winding=0;
  for(const path of solPaths){
    const r=ClipperLib.Clipper.PointInPolygon(cp,path);
    if(r===-1)return true; // on boundary
    if(r!==0){
      const sign=Math.sign(ClipperLib.Clipper.Area(path))||1;
      winding+=sign;
    }
  }
  return winding!==0;
}
function ptStrictInArea(pt,solPaths){
  if(!solPaths||solPaths.length===0)return false;
  const cp={X:Math.round(pt[0]*CS),Y:Math.round(pt[1]*CS)};
  let winding=0;
  for(const path of solPaths){
    const r=ClipperLib.Clipper.PointInPolygon(cp,path);
    if(r===-1)return false;
    if(r!==0){
      const sign=Math.sign(ClipperLib.Clipper.Area(path))||1;
      winding+=sign;
    }
  }
  return winding!==0;
}

// Binary search for the approximate boundary crossing between two points
function findCrossing(pIn,pOut,area){
  let a=0,b=1;
  for(let i=0;i<12;i++){
    const t=(a+b)/2;
    const pm=[pIn[0]+(pOut[0]-pIn[0])*t,pIn[1]+(pOut[1]-pIn[1])*t];
    if(ptInArea(pm,area))a=t; else b=t;
  }
  const t=(a+b)/2;
  return[pIn[0]+(pOut[0]-pIn[0])*t,pIn[1]+(pOut[1]-pIn[1])*t];
}

// Clip a closed contour to only keep segments inside an area.
// Returns array of open polylines (the seam segments).
function clipContourToArea(contour,area){
  const n=contour.length;
  if(n<3)return[];
  const results=[];
  let run=[];

  // Pre-compute inside status for all points
  const inside=contour.map(p=>ptInArea(p,area));

  for(let i=0;i<n;i++){
    const j=(i+1)%n;

    // Add current point if inside
    if(inside[i]){
      run.push(contour[i]);
    }

    // Check for transitions on edge i->j
    if(inside[i]&&!inside[j]){
      // EXITING: add crossing point, save run
      run.push(findCrossing(contour[i],contour[j],area));
      if(run.length>=2)results.push(run);
      run=[];
    }else if(!inside[i]&&inside[j]){
      // ENTERING: start new run at crossing point
      run.push(findCrossing(contour[j],contour[i],area));
    }
  }
  // Save any remaining run
  if(run.length>=2)results.push(run);

  // Merge wrap-around: if first point was inside, last run connects to first run
  if(results.length>=2&&inside[0]){
    const first=results[0],last=results[results.length-1];
    results[0]=[...last,...first];
    results.pop();
  }

  return results;
}
function collectSeamsForArea(contours,area,allowClosed=true,solidArea=null){
  const collected=[];
  if(!area||area.length===0)return collected;
  for(const contour of contours){
    const seams=clipContourToArea(contour,area);
    for(const seg of seams){
      if(seg.length<2)continue;
      const segLen=polylineLength(seg);
      if(segLen<MIN_SEAM_LEN)continue;
      if(solidArea&&!isInternalSeam(seg,solidArea))continue;
      collected.push({seg,contourLen:contour.length,allowClosed});
    }
  }
  return collected;
}
function appendSeamsForArea(contours,area,seamPathDs,allowClosed=true,solidArea=null){
  for(const item of collectSeamsForArea(contours,area,allowClosed,solidArea)){
    const {seg,contourLen}=item;
    const d0=Math.hypot(seg[seg.length-1][0]-seg[0][0],seg[seg.length-1][1]-seg[0][1]);
    if(allowClosed&&seg.length>=contourLen*0.9 && d0<3){
      seamPathDs.push(closedSmooth(seg));
    }else{
      seamPathDs.push(openSmooth(seg));
    }
  }
}
function clipContourOutsideArea(contour,area){
  const n=contour.length;
  if(n<3)return[];
  const results=[];
  let run=[];
  const outside=contour.map(p=>!ptInArea(p,area));
  for(let i=0;i<n;i++){
    const j=(i+1)%n;
    if(outside[i])run.push(contour[i]);
    if(outside[i]&&!outside[j]){
      run.push(findCrossing(contour[j],contour[i],area));
      if(run.length>=2)results.push(run);
      run=[];
    }else if(!outside[i]&&outside[j]){
      run.push(findCrossing(contour[i],contour[j],area));
    }
  }
  if(run.length>=2)results.push(run);
  if(results.length>=2&&outside[0]){
    const first=results[0],last=results[results.length-1];
    results[0]=dedupeRunPoints([...last,...first.slice(1)]);
    results.pop();
  }
  return results;
}
function densify(c,step=3){
  const out=[];
  for(let i=0;i<c.length;i++){
    const a=c[i],b=c[(i+1)%c.length],n=Math.max(1,Math.ceil(Math.hypot(b[0]-a[0],b[1]-a[1])/step));
    for(let k=0;k<n;k++)out.push([a[0]+(b[0]-a[0])*k/n,a[1]+(b[1]-a[1])*k/n]);
  }
  return out;
}
function appendVisibleLetterSeams(contoursIn,occluderArea,seamPathDs){
  const contours=contoursIn.map(c=>densify(c));
  for(const contour of contours){
    if(!contour||contour.length<3)continue;
    if(!occluderArea||occluderArea.length===0){
      seamPathDs.push(closedSmooth(contour));
      continue;
    }
    const fullyVisible=contour.every(pt=>!ptInArea(pt,occluderArea));
    if(fullyVisible){
      seamPathDs.push(closedSmooth(contour));
      continue;
    }
    for(const seg of clipContourOutsideArea(contour,occluderArea)){
      const clean=dedupeRunPoints(seg);
      if(clean.length>=2&&polylineLength(clean)>=1){
        seamPathDs.push(openSmooth(clean));
      }
    }
  }
}
function endpointDir(seg,atEnd){
  if(seg.length<2)return[1,0];
  const a=atEnd?seg[seg.length-2]:seg[1];
  const b=atEnd?seg[seg.length-1]:seg[0];
  const dx=b[0]-a[0],dy=b[1]-a[1];
  const len=Math.hypot(dx,dy)||1;
  return[dx/len,dy/len];
}
function reversed(seg){return seg.slice().reverse();}
function mergeOpenSeamSegments(segments,maxGap=6,minDot=0.35){
  const pool=segments.map(seg=>seg.slice());
  let changed=true;
  while(changed){
    changed=false;
    outer:
    for(let i=0;i<pool.length;i++){
      for(let j=i+1;j<pool.length;j++){
        const a=pool[i],b=pool[j];
        const variants=[
          [a,b,false,false],
          [a,reversed(b),false,true],
          [reversed(a),b,true,false],
          [reversed(a),reversed(b),true,true],
        ];
        for(const [va,vb,revA,revB] of variants){
          const endA=va[va.length-1],startB=vb[0];
          const gap=Math.hypot(endA[0]-startB[0],endA[1]-startB[1]);
          if(gap>maxGap)continue;
          const da=endpointDir(va,true),db=endpointDir(vb,false);
          const dot=da[0]*db[0]+da[1]*db[1];
          if(dot<minDot)continue;
          const bridge=gap>0.01?[[ (endA[0]+startB[0])/2,(endA[1]+startB[1])/2 ]]:[];
          const merged=[...va,...bridge,...vb.slice(1)];
          pool[i]=merged;
          pool.splice(j,1);
          changed=true;
          break outer;
        }
      }
    }
  }
  return pool;
}
function pointSegmentDistance(pt,a,b){
  const abx=b[0]-a[0],aby=b[1]-a[1];
  const ab2=abx*abx+aby*aby;
  if(!ab2)return Math.hypot(pt[0]-a[0],pt[1]-a[1]);
  let t=((pt[0]-a[0])*abx+(pt[1]-a[1])*aby)/ab2;
  t=Math.max(0,Math.min(1,t));
  const x=a[0]+abx*t,y=a[1]+aby*t;
  return Math.hypot(pt[0]-x,pt[1]-y);
}
function pointPolylineDistance(pt,line){
  if(!line||line.length<2)return Infinity;
  let best=Infinity;
  for(let i=1;i<line.length;i++){
    best=Math.min(best,pointSegmentDistance(pt,line[i-1],line[i]));
  }
  return best;
}
function pointToSeamsDistance(pt,seams){
  let best=Infinity;
  for(const line of seams){
    best=Math.min(best,pointPolylineDistance(pt,line));
  }
  return best;
}
function dedupeRunPoints(pts){
  if(pts.length<2)return pts.slice();
  const out=[pts[0]];
  for(let i=1;i<pts.length;i++){
    const a=out[out.length-1],b=pts[i];
    if(Math.hypot(a[0]-b[0],a[1]-b[1])>0.01)out.push(b);
  }
  return out;
}
function collectContourSegmentsByPredicate(contour,predicate){
  const n=contour.length;
  if(n<2)return[];
  const hits=new Array(n).fill(false);
  for(let i=0;i<n;i++){
    const a=contour[i],b=contour[(i+1)%n];
    const mid=[(a[0]+b[0])/2,(a[1]+b[1])/2];
    hits[i]=predicate(a,b,mid,i);
  }
  const runs=[];
  let run=[];
  for(let i=0;i<n;i++){
    const a=contour[i],b=contour[(i+1)%n];
    if(hits[i]){
      if(run.length===0)run.push(a);
      run.push(b);
    }else if(run.length){
      runs.push(dedupeRunPoints(run));
      run=[];
    }
  }
  if(run.length){
    if(runs.length&&hits[0]){
      runs[0]=dedupeRunPoints([...run.slice(0,-1),...runs[0]]);
    }else{
      runs.push(dedupeRunPoints(run));
    }
  }
  return runs.filter(seg=>seg.length>=2&&polylineLength(seg)>=MIN_SEAM_LEN);
}


// ==================================================================
// GEOMETRY PIPELINE
// ==================================================================

function process(){
  if(!font||!S.name.trim())return null;

  const emSc=S.fontSize/font.unitsPerEm, chars=[...S.name.trim()];
  const sp=S.letterSpacing*S.fontSize/FONTS[S.fontKey].size;   // spacing scales with the letters
  let nx=0;
  const layout=chars.map(ch=>{
    const adv=(font.charToGlyph(ch).advanceWidth||0)*emSc;
    const e={char:ch,nx};nx+=adv+sp;return e;
  });
  const lastL=layout[layout.length-1];
  const totalW=lastL.nx+(font.charToGlyph(lastL.char).advanceWidth||0)*emSc;
  const baseX=(W-totalW)/2;

  // Letter contours at baseline 0 -> measure true name height (tallest top / lowest bottom)
  // Merge the overlapping parts inside each glyph (nonzero fill, as the font intends) so seams follow the true letter outline
  function glyphUnion(contours){
    const subject=contours.filter(c=>c.length>=3).map(toCP);
    if(!subject.length)return[];
    const clipper=new ClipperLib.Clipper();
    clipper.AddPaths(ClipperLib.Clipper.SimplifyPolygons(subject,ClipperLib.PolyFillType.pftNonZero),ClipperLib.PolyType.ptSubject,true);
    const sol=new ClipperLib.Paths();
    clipper.Execute(ClipperLib.ClipType.ctUnion,sol,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
    return ClipperLib.Clipper.CleanPolygons(sol,0.15*CS).filter(p=>Math.abs(ClipperLib.Clipper.Area(p))>5*CS*CS).map(fromCP);
  }
  let letterContours=layout.map(({char,nx:lx})=>{
    const cmds=font.getPath(char,baseX+lx,0,S.fontSize).commands;
    return glyphUnion(flatten(cmds,FLATTEN_TOL));
  });
  // Per-letter top (whole letter), for letters that sit under the snowflake
  const isLower=ch=>ch===ch.toLowerCase()&&ch!==ch.toUpperCase();
  const measure=spanOnly=>letterContours.map((cs,i)=>{
    let top=Infinity,x0=Infinity,x1=-Infinity;
    for(const c of cs)for(const p of c){if(p[1]<top)top=p[1];if(p[0]<x0)x0=p[0];if(p[0]>x1)x1=p[0];}
    return{top,x0,x1,ch:chars[i]};
  }).filter(o=>isFinite(o.top)&&(!spanOnly||(o.x1>=W/2-BAR_HALF*SF_SCALE&&o.x0<=W/2+BAR_HALF*SF_SCALE)));
  let info=measure(true);if(!info.length)info=measure(false);
  if(!info.length)return null;
  // Top half touches the lowercase letters (their lowest-sitting top); all-caps names use the caps; punctuation is ignored when there are letters
  const letters=info.filter(o=>/\p{L}/u.test(o.ch)),base=letters.length?letters:info;
  const lowers=base.filter(o=>isLower(o.ch)),pool=lowers.length?lowers:base;
  const nMinY=Math.min(Math.max(...pool.map(o=>o.top)),-0.3*S.fontSize);   // never let the halves collapse onto each other
  // Bottom half: meets the baseline of the word (descenders like p, y, g poke down into it)
  const nMaxY=0;                              // letters are laid out on baseline y=0 here
  // bottom overlap grows a little with letter size so big letters still weld firmly
  const botOv=NAME_OVERLAP+Math.max(0,S.fontSize-100)*BOT_OVERLAP_GROW;
  const L=snowLayout(nMaxY-nMinY,botOv);
  const dy=L.nameTop-nMinY;   // shift name so the reference tops sit at the computed position
  letterContours=letterContours.map(cs=>cs.map(c=>c.map(p=>[p[0],p[1]+dy])));

  // Snowflake halves in screen space
  const topContours=flatten(xfCmds(parsePath(SNOW_TOP),L.topTf.sc,L.topTf.tx,L.topTf.ty),FLATTEN_TOL);
  const botContours=flatten(xfCmds(parsePath(SNOW_BOT),L.botTf.sc,L.botTf.tx,L.botTf.ty),FLATTEN_TOL);

  // CUT: union of both snowflake halves + all letters
  const weldedSol=clipperUnion([topContours,botContours,...letterContours]);
  // Convert Clipper solution to smooth SVG paths
  const weldedCutPaths=weldedSol.map(p=>fromCP(p));
  const frontCutPathD=rawFillPath(weldedCutPaths);
  let backCutArea=weldedSol.slice();
  let ringHoleArea=[];
  if(S.hoopEnabled){
    const h=hoopPos(L.topY);
    const ringOuterArea=buildArea([[circleContour(h.cx,h.cy,HR)]]);
    ringHoleArea=buildArea([[circleContour(h.cx,h.cy,hIR)]]);
    backCutArea=diffAreas(unionAreas([...backCutArea,...ringOuterArea]),ringHoleArea);
  }
  backCutArea=offsetAreas(backCutArea,BACK_OFFSET);
  // solid backing: keep outer outlines only (drop interior voids between letters and snowflake bars)
  if(backCutArea.length){
    let big=backCutArea[0];for(const p of backCutArea)if(Math.abs(ClipperLib.Clipper.Area(p))>Math.abs(ClipperLib.Clipper.Area(big)))big=p;
    const outerSign=Math.sign(ClipperLib.Clipper.Area(big));
    backCutArea=backCutArea.filter(p=>Math.sign(ClipperLib.Clipper.Area(p))===outerSign);
  }
  if(ringHoleArea.length)backCutArea=diffAreas(backCutArea,ringHoleArea);
  const backCutBounds=clipperBounds(backCutArea);
  const backCutPathD=rawFillPath(backCutArea.map(p=>fromCP(p)));

  // SCORE: full letter seams, preserving overlap order
  const seamPathDs=[];
  for(let i=0;i<letterContours.length;i++){
    const frontArea=i<letterContours.length-1?buildArea(letterContours.slice(i+1)):[];
    appendVisibleLetterSeams(letterContours[i],frontArea,seamPathDs);
  }

  // Letter fills for preview (individual fills so they show layering)
  const letterFills=letterContours.map(c=>rawFillPath(c));

  return{frontCutPathD, backCutPathD, backCutBounds, seamPathDs, letterFills};
}

// Preview render
function renderFallback(){
  document.getElementById('boardSvg').setAttribute('viewBox',`0 0 ${W} ${H}`);
  const L=snowLayout(S.fontSize*0.55),h=S.hoopEnabled?hoopPos(L.topY):null,nm=S.name||'...';
  const g=(t,d,extra='')=>`<g transform="${gTf(t)}"><path d="${d}" ${extra}/></g>`;
  const bk=`fill="${BACK_FILL}" stroke="${BACK_FILL}" stroke-width="14" stroke-linejoin="round" paint-order="stroke fill"`;
  const p=[
    `<rect width="${W}" height="${H}" fill="${BG}"/>`,
    g(L.topTf,SNOW_TOP,bk),g(L.botTf,SNOW_BOT,bk),
  ];
  if(h){p.push(`<path d="${ringPath(h)}" fill="${BACK_FILL}" fill-rule="evenodd"/>`);p.push(`<circle cx="${h.cx.toFixed(2)}" cy="${h.cy.toFixed(2)}" r="${hIR}" fill="${BG}"/>`);}
  p.push(
    g(L.topTf,SNOW_TOP,`fill="${BEIGE}"`),g(L.botTf,SNOW_BOT,`fill="${BEIGE}"`),
    `<text x="${W/2}" y="${L.nameTop+S.fontSize*.72}" font-family="${FONTS[S.fontKey].family}" font-size="${S.fontSize}" text-anchor="middle" fill="${BEIGE}" stroke="${BROWN}" stroke-width="2.5" stroke-linejoin="round" paint-order="stroke fill">${nm.replace(/&/g,'&amp;').replace(/</g,'&lt;')}</text>`,
  );
  document.getElementById('boardSvg').innerHTML=p.join('');
}

function previewBox(){
  let x0=0,y0=0,x1=W,y1=H;
  const b=data&&data.backCutBounds;
  if(b){x0=Math.min(x0,b.x-PREVIEW_PAD);y0=Math.min(y0,b.y-PREVIEW_PAD);x1=Math.max(x1,b.x+b.w+PREVIEW_PAD);y1=Math.max(y1,b.y+b.h+PREVIEW_PAD);}
  return{x:x0,y:y0,w:x1-x0,h:y1-y0};
}
function renderResult(){
  if(!ready||!font||!data){renderFallback();return;}
  const vb=previewBox();
  document.getElementById('boardSvg').setAttribute('viewBox',`${vb.x.toFixed(1)} ${vb.y.toFixed(1)} ${vb.w.toFixed(1)} ${vb.h.toFixed(1)}`);
  const p=[
    `<rect x="${vb.x}" y="${vb.y}" width="${vb.w}" height="${vb.h}" fill="${BG}"/>`,
    `<path d="${data.backCutPathD}" fill="${BACK_FILL}" fill-rule="evenodd"/>`,
  ];
  p.push(
    `<path d="${data.frontCutPathD}" fill="${BEIGE}" fill-rule="evenodd"/>`,
    ...data.seamPathDs.map(d=>`<path d="${d}" fill="none" stroke="${BROWN}" stroke-width="${PSW}" stroke-linecap="round" stroke-linejoin="round"/>`),
  );
  document.getElementById('boardSvg').innerHTML=p.join('\n');
}

function showOv(m){document.getElementById('procMsg').textContent=m;document.getElementById('procOverlay').classList.add('show');}
function hideOv(){document.getElementById('procOverlay').classList.remove('show');}
function runProcess(){
  try{data=process();}catch(e){console.error(e);data=null;}
  document.getElementById('dlBtn').disabled=!data;syncExportUi();renderResult();
}
function sched(d=40){
  clearTimeout(timer);
  if(!ready||!font){renderFallback();return;}
  timer=setTimeout(()=>requestAnimationFrame(runProcess),d);   // old drawing stays on screen until the new one is ready
}

// Export SVG
function buildSVG(){
  if(!data)return null;
  const unit=S.exportUnit;
  const eH=mmToUnit(S.exportHeightMm,unit);
  const bounds=currentBackBounds();
  const scale=eH/Math.max(bounds.h,1e-6);
  const eW=bounds.w*scale;
  const SW=2;                                   // export line thickness
  const layerY=bounds.y+bounds.h+46;            // layer labels sit under each layer
  const LW=84.4,RW=106.3,BW=151.6,SP=6.1;       // text widths (Arial Bold 22px) so each label can be centred under its layer without relying on tspans
  const LBL1=LW+SP+RW,LBL2=LW+SP+RW+BW;
  const vbH=Math.max(H,layerY+26);
  const totW=2*W+GAP,totWOut=totW*scale,totHOut=vbH*scale;
  const backCutEl=`    <path fill="none" stroke="#FF0000" stroke-width="${SW}" stroke-linejoin="round" d="${data.backCutPathD}"/>`;
  const frontCutEl=`    <path fill="none" stroke="#FF0000" stroke-width="${SW}" stroke-linejoin="round" d="${data.frontCutPathD}"/>`;

  // Score paths: visible letter outlines with overlap ordering
  const scoreEls=data.seamPathDs.map((d,i)=>
    `      <path id="seam-${i}" fill="none" stroke="#5C3317" stroke-width="${SW}" stroke-linecap="round" stroke-linejoin="round" d="${d}"/>`
  ).join('\n');

  return[
    `<?xml version="1.0" encoding="utf-8"?>`,
    `<!--`,
    `  Snowflake Name Ornament — Laser Export`,
    `  Name: "${S.name}"  |  ${FONTS[S.fontKey].label}  |  ${S.fontSize}pt  |  Spacing: ${S.letterSpacing}px  |  Ring: ${S.hoopEnabled}`,
    `  Panel size: ${fmtMeasure(eW,unit)} x ${fmtMeasure(eH,unit)} ${unit}`,
    `  LEFT = back layer   RIGHT = front layer`,
    `  Cut = united snowflake halves + letters outline; back layer also merges hanging ring when enabled`,
    `  Score = layered letter seams (full letter outlines with overlap order)`,
    `  Cut = #FF0000  |  Score = #5C3317  |  stroke-width = 2`,
    `-->`,
    `<svg xmlns="http://www.w3.org/2000/svg"`,
    `     xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"`,
    `     viewBox="0 0 ${totW} ${vbH}" width="${fmtMeasure(totWOut,unit)}${unit}" height="${fmtMeasure(totHOut,unit)}${unit}">`,
    ``,
    `  <!-- ══ LEFT PANEL: BACK LAYER ══ -->`,
    `  <g id="back" inkscape:groupmode="layer" inkscape:label="Back - Cut">`,
    backCutEl,
    `  </g>`,
    ``,
    `  <!-- ══ RIGHT PANEL: FRONT LAYER ══ -->`,
    `  <g id="front" transform="translate(${W+GAP},0)">`,
    `    <g id="front-cut" inkscape:groupmode="layer" inkscape:label="Front - Cut">`,
    frontCutEl,
    `    </g>`,
    `    <g id="front-score" inkscape:groupmode="layer" inkscape:label="Front - Score">`,
    scoreEls,
    `    </g>`,
    `  </g>`,
    ``,
    `  <!-- ══ CUT GUIDE (delete or hide this layer before cutting) ══ -->`,
    `  <g id="cut-guide" inkscape:groupmode="layer" inkscape:label="Cut Guide">`,
    `    <text x="${(W/2-LBL1/2).toFixed(2)}" y="${layerY.toFixed(2)}" font-family="Arial,Helvetica,sans-serif" font-size="22" font-weight="700" fill="#000000">Layer 1:</text>`,
    `    <text x="${(W/2-LBL1/2+LW+SP).toFixed(2)}" y="${layerY.toFixed(2)}" font-family="Arial,Helvetica,sans-serif" font-size="22" font-weight="700" fill="#FF0000">Red - CUT</text>`,
    `    <text x="${(W+GAP+W/2-LBL2/2).toFixed(2)}" y="${layerY.toFixed(2)}" font-family="Arial,Helvetica,sans-serif" font-size="22" font-weight="700" fill="#000000">Layer 2:</text>`,
    `    <text x="${(W+GAP+W/2-LBL2/2+LW+SP).toFixed(2)}" y="${layerY.toFixed(2)}" font-family="Arial,Helvetica,sans-serif" font-size="22" font-weight="700" fill="#FF0000">Red - CUT</text>`,
    `    <text x="${(W+GAP+W/2-LBL2/2+LW+SP+RW).toFixed(2)}" y="${layerY.toFixed(2)}" font-family="Arial,Helvetica,sans-serif" font-size="22" font-weight="700" fill="#000000">,&#160;Black - Score</text>`,
    `  </g>`,
    ``,
    `</svg>`,
  ].join('\n');
}
const IS_MOBILE=/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)||(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1);
const IN_APP=/FBAN|FBAV|FB_IAB|Instagram|TikTok|musical_ly|Snapchat|Pinterest|LinkedInApp|MicroMessenger|Line\/|; wv\)|Etsy/i.test(navigator.userAgent);
async function download(){
  const s=buildSVG();if(!s){alert('Generate a name first.');return;}
  const fname=`snowflake-${(S.name||'name').replace(/[^a-z0-9]/gi,'-')}-laser.svg`;
  // Phones/tablets: hand the file to the system share sheet ("Save to Files", Drive, email...) - the most reliable way to keep a file on mobile
  if(IS_MOBILE&&navigator.canShare&&typeof File==='function'){
    try{
      const file=new File([s],fname,{type:'image/svg+xml'});
      if(navigator.canShare({files:[file]})){await navigator.share({files:[file],title:fname});return;}
    }catch(e){if(e&&e.name==='AbortError')return;}   // closed the sheet = done; any other error falls through to a normal download
  }
  // Everywhere else: normal download link; keep the blob alive long enough for slow mobile browsers to read it
  const url=URL.createObjectURL(new Blob([s],{type:'image/svg+xml;charset=utf-8'}));
  const a=Object.assign(document.createElement('a'),{href:url,download:fname,rel:'noopener'});
  a.style.display='none';document.body.appendChild(a);a.click();
  setTimeout(()=>{a.remove();URL.revokeObjectURL(url);},60000);
}
// Social-app browsers (Instagram, Facebook, TikTok, Etsy...) block file downloads: tell the visitor how to get out of them
if(IN_APP){const n=document.getElementById('dlNote');n.textContent='Downloads can be blocked inside this app. If the file does not save, open this page in Safari or Chrome (tap the ... or share menu, then "Open in browser").';n.style.display='block';}

// Reset
async function reset(){
  Object.assign(S,DEF);
  sizeManual=false;
  document.getElementById('ni').value=S.name;
  document.getElementById('fontSel').value=S.fontKey;syncFontUi();
  document.getElementById('ni').style.fontFamily=FONTS[S.fontKey].family;
  document.getElementById('szSlider').value=S.fontSize;
  document.getElementById('spSlider').value=S.letterSpacing;
  syncExportUi();
  document.querySelectorAll('#hoopSeg .sb').forEach(b=>b.classList.toggle('on',b.dataset.hoop===String(S.hoopEnabled)));
  await loadFont(S.fontKey);
  sched();
}

// Controls
document.getElementById('ni').value=S.name;
// Names longer than AUTO_MAX_CHARS shrink automatically; once the person touches the size slider their size is kept
const AUTO_MAX_CHARS=7;let sizeManual=false;
function nameWidth(str,size,L){   // same layout maths as process()
  const base=FONTS[S.fontKey].size,ch=[...str.trim()],em=size/font.unitsPerEm,sp=L*size/base;let w=0;
  ch.forEach((c,i)=>{w+=(font.charToGlyph(c).advanceWidth||0)*em+(i<ch.length-1?sp:0);});
  return w;
}
function autoSize(name){   // names over 7 letters are fitted to one fixed width (about a typical 7-letter name in the chosen font)
  const F=FONTS[S.fontKey],n=[...name.trim()].length;
  if(n<=AUTO_MAX_CHARS)return F.size;
  if(!font)return Math.max(40,Math.round(F.size*AUTO_MAX_CHARS/n));
  const w=nameWidth(name,F.size,S.letterSpacing);                // width if drawn at the font's default size
  return Math.max(40,Math.min(F.size,Math.floor(F.size*F.fit/w)));
}
document.getElementById('ni').addEventListener('input',e=>{
  S.name=e.target.value;
  if(!sizeManual){S.fontSize=autoSize(S.name);document.getElementById('szSlider').value=S.fontSize;}
  sched(120);
});
document.getElementById('fontSel').addEventListener('change',async e=>{
  const key=e.target.value;
  if(!(await loadFont(key))){
    e.target.value=S.fontKey;syncFontUi();showOv('Could not load that font');setTimeout(hideOv,2200);sched();return;
  }
  S.fontKey=key;const F=FONTS[key];
  document.getElementById('ni').style.fontFamily=F.family;
  S.letterSpacing=F.spacing;document.getElementById('spSlider').value=S.letterSpacing;
  if(!sizeManual){S.fontSize=autoSize(S.name);document.getElementById('szSlider').value=S.fontSize;}
  sched(0);
});
// Font drop-down (custom, so it matches the panel); the hidden <select> holds the value
function syncFontUi(){
  const v=document.getElementById('fontSel').value,F=FONTS[v],t=document.getElementById('fontBtnTxt');
  t.textContent=F.label;t.style.fontFamily=F.family;
  document.querySelectorAll('#fontList li').forEach(li=>{const on=li.dataset.v===v;li.classList.toggle('on',on);li.setAttribute('aria-selected',on?'true':'false');});
}
(function(){
  const dd=document.getElementById('fontDd'),btn=document.getElementById('fontBtn'),list=document.getElementById('fontList'),sel=document.getElementById('fontSel');
  const items=[...list.querySelectorAll('li')];let act=-1;
  const isOpen=()=>list.classList.contains('open');
  const mark=i=>{act=i;items.forEach((li,k)=>li.classList.toggle('act',k===i));};
  function open(){list.classList.add('open');dd.classList.add('open');btn.setAttribute('aria-expanded','true');mark(Math.max(0,items.findIndex(li=>li.dataset.v===sel.value)));}
  function close(){list.classList.remove('open');dd.classList.remove('open');btn.setAttribute('aria-expanded','false');mark(-1);}
  function choose(v){
    close();
    if(sel.value!==v){sel.value=v;syncFontUi();sel.dispatchEvent(new Event('change'));}
  }
  btn.addEventListener('click',()=>isOpen()?close():open());
  items.forEach(li=>li.addEventListener('click',()=>{choose(li.dataset.v);btn.focus();}));
  document.addEventListener('click',e=>{if(!dd.contains(e.target))close();});
  btn.addEventListener('keydown',e=>{
    const k=e.key;
    if(k==='Escape'&&isOpen()){e.preventDefault();close();}
    else if(k==='ArrowDown'||k==='ArrowUp'){e.preventDefault();if(!isOpen())open();else mark((act+(k==='ArrowDown'?1:-1)+items.length)%items.length);}
    else if(k==='Home'&&isOpen()){e.preventDefault();mark(0);}
    else if(k==='End'&&isOpen()){e.preventDefault();mark(items.length-1);}
    else if((k==='Enter'||k===' ')&&isOpen()){e.preventDefault();choose(items[Math.max(0,act)].dataset.v);}
    else if(k==='Tab'&&isOpen())close();
  });
  sel.addEventListener('change',syncFontUi);
  syncFontUi();
})();
document.getElementById('szSlider').addEventListener('input',e=>{sizeManual=true;S.fontSize=parseInt(e.target.value);sched(0);});
document.getElementById('spSlider').addEventListener('input',e=>{S.letterSpacing=parseInt(e.target.value);sched(0);});
document.getElementById('hoopSeg').addEventListener('click',e=>{
  const b=e.target.closest('.sb');if(!b)return;
  document.querySelectorAll('#hoopSeg .sb').forEach(x=>x.classList.remove('on'));
  b.classList.add('on');S.hoopEnabled=(b.dataset.hoop==='true');sched(20);
});
document.getElementById('ehInput').addEventListener('input',e=>{
  const raw=parseFloat(e.target.value);
  if(!Number.isFinite(raw))return;
  S.exportHeightMm=Math.max(EXPORT_MIN_MM,Math.min(EXPORT_MAX_MM,unitToMm(raw,S.exportUnit)));
  document.getElementById('exportDims').textContent=fmtExportDims();
});
document.getElementById('ehInput').addEventListener('change',e=>{
  const raw=parseFloat(e.target.value);
  if(Number.isFinite(raw))S.exportHeightMm=Math.max(EXPORT_MIN_MM,Math.min(EXPORT_MAX_MM,unitToMm(raw,S.exportUnit)));
  syncExportUi();
});
document.getElementById('unitSeg').addEventListener('click',e=>{
  const b=e.target.closest('.sb');if(!b)return;
  S.exportUnit=b.dataset.unit;
  syncExportUi();
});
document.getElementById('dlBtn').addEventListener('click',download);
document.getElementById('resetBtn').addEventListener('click',reset);
syncExportUi();

// Init: controls start from the defaults (font, sliders)
document.getElementById('fontSel').value=S.fontKey;syncFontUi();
document.getElementById('ni').style.fontFamily=FONTS[S.fontKey].family;
document.getElementById('szSlider').value=S.fontSize;
document.getElementById('spSlider').value=S.letterSpacing;
showOv('Loading libraries...');renderFallback();
Promise.all([loadScript(LIB.opentype),loadScript(LIB.clipper)])
.then(()=>{
  if(typeof opentype==='undefined')throw new Error('opentype not defined');
  if(typeof ClipperLib==='undefined')throw new Error('ClipperLib not defined');
  ready=true;return document.fonts.ready;
})
.then(()=>loadFont(S.fontKey))
.then(ok=>{if(ok)sched();else showOv('Font load failed - reload.');})
.catch(err=>{showOv(`Failed: ${err.message} - reload`);console.error(err);});

})();